/**
 * 在对象中查找key
 * @param obj
 * @param val
 * @returns {*}
 */
import ResultResponse from '../pb/resultresponse.pb';

function findKey(obj, val) {
    let k = null;
    Object.keys(obj).forEach((item) => {
        if (obj[item] === val) {
            k = item;
        }
    });
    return k;
}

/**
 * 解析pb返回的数据
 * @param resp 相应的数据
 * @param pbObj pb对象
 * @param api 请求的URL
 * @returns {{code, data: *}}
 */
function decodeData(resp, pbObj, api) {
    const dataWrapper = ResultResponse.Result.decode(resp);
    let data = null;
    // console.groupCollapsed(`%c 返回的数据【${findKey(window.ResultResponse.Code, dataWrapper.code)}】 ===>  ${api}`, 'color:green');
    // console.log(dataWrapper);
    // console.groupEnd();
    // 检查下数据
    if (dataWrapper.data && dataWrapper.data.value) {
        /** @namespace pbObj.Response */
        data = pbObj.Response.decode(dataWrapper.data.value);
        // console.groupCollapsed(`%c 解析后的数据 ${api}`, 'color:red');
        // console.log(data);
        // console.groupEnd();
    }
    
    return {
        code: dataWrapper.code,
        result: data
    };
}


export {decodeData};

export default decodeData;



// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/request/pbdecoder.js